import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { PaymentOption } from '../../typings/Payment'

import PaymentMethodExpansionPanelHeaderIcon from './PaymentMethodExpansionPanelHeaderIcon'
import PaymentMethodExpansionPanelHeaderText from './PaymentMethodExpansionPanelHeaderText'

interface Props {
  paymentOption: PaymentOption
}

const PaymentMethodExpansionPanelHeader: React.FC<React.PropsWithChildren<Props>> = ({ paymentOption }) => {
  const headerText = <PaymentMethodExpansionPanelHeaderText paymentOption={paymentOption} />

  return (
    <Flex alignItems="center" marginRight="wide">
      <PaymentMethodExpansionPanelHeaderIcon paymentOption={paymentOption} />
      <Text fontWeight="bold" marginBottom="dense" marginLeft="wide">
        {headerText}
      </Text>
    </Flex>
  )
}

export default PaymentMethodExpansionPanelHeader
